import { Button } from '@/components/common/button'
import { ProtocolImage } from '@/components/common/protocolImage'
import { TabsContent } from '@/components/common/tabs'
import { ExternalLinkIcon } from '@/components/icons/externalLink'
import { WalletIcon } from '@/components/icons/wallet'
import { routes } from '@/config/routes'
import type { Vault } from '@/types/vault'
import { getProtocolDisplayName } from '@/utils/protocol'
import { Link } from 'react-router'

export const CLAIM_REWARDS_EXCEPTION_TAB_NAME = 'claim-exception'

interface Props {
  vault: Vault
}

export function ClaimRewardsExceptionTab({ vault }: Props) {
  return (
    <form>
      <TabsContent value={CLAIM_REWARDS_EXCEPTION_TAB_NAME} className="mt-3 flex flex-col gap-3 md:mt-4 md:gap-4">
        {vault.transactionalProperties?.rewardsSupported ? (
          <InternalClaimContent />
        ) : (
          <ExternalClaimContent vault={vault} />
        )}
      </TabsContent>
    </form>
  )
}

const InternalClaimContent = () => {
  return (
    <>
      <p className="inline-flex items-center gap-1 text-xs">
        Go to the
        <WalletIcon size={16} />
        Dashboard to claim rewards
      </p>
      <Button type="button" size="sm" className="gap-2" asChild>
        <Link to={routes.dashboard}>
          Go to the Dashboard
          <ExternalLinkIcon />
        </Link>
      </Button>
    </>
  )
}

const ExternalClaimContent = ({ vault }: { vault: Vault }) => {
  const { protocol, protocolVaultUrl } = vault
  const protocolDisplayName = getProtocolDisplayName(protocol)

  return (
    <>
      <p className="inline-flex items-center gap-1 text-xs">
        Go to
        <ProtocolImage protocol={protocol} />
        <span>{protocolDisplayName}</span>
        app to claim rewards
      </p>
      <Button type="button" size="sm" className="gap-2" asChild>
        <a href={protocolVaultUrl ?? ''} target="_blank" rel="noopener noreferrer">
          Go to the protocol app
          <ExternalLinkIcon />
        </a>
      </Button>
    </>
  )
}
